// ** Toolkit imports
import { configureStore } from "@reduxjs/toolkit";

// ** Reducers
import auth from "./apps/auth";
import user from "./apps/user";
import device from "./apps/device";
import xtream from "./apps/xtream";
import setting from "./apps/setting";
import playlist from "./apps/playlist";


export const store = configureStore({
  reducer: {
    auth,
    user,
    device,
    xtream,
    setting,
    playlist
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

